export default (props, e) => {
	e.preventDefault();
	const dropDowns = document.querySelectorAll('.header .dropdown');
	const fulltextQuery = document.getElementById('query');
	const fulltextDropdown = document.getElementById('js_fulltextDropdown');
	const fulltextDropdownContent = document.getElementById('js_fulltextDropdownContent');

	if (fulltextDropdown.classList.contains('opened')) {
		fulltextDropdown.classList.remove('opened');
		if(fulltextDropdownContent.hasAttribute('aria-hidden')) {
			fulltextDropdownContent.setAttribute('aria-hidden', 'true');
		}
		document.body.classList.remove('megamenu-opened');
	} else {
		dropDowns.forEach((dropDown) => {
			dropDown.classList.remove('opened');
		});
		fulltextDropdown.classList.add('opened');
		if(fulltextDropdownContent.hasAttribute('aria-hidden')) {
			fulltextDropdownContent.setAttribute('aria-hidden', 'false');
		}
		fulltextQuery.focus();
		document.body.classList.add('megamenu-opened');
	}

	document.addEventListener('keydown', _closeFulltextDropdownOnEscape);

	function _closeFulltextDropdownOnEscape(e) {
		if (document.getElementById('js_fulltextDropdown').classList.contains('opened') && e.key === "Escape") {
			document.querySelector('.fulltext .btn-close').click();
		}
	}
};


// WEBPACK FOOTER //
// ./fe/web-uhkPoint/src/js/webActions/headerNavFulltextHandler.js